import React from 'react';

import CommonLayout from '../common/CommonLayout';

function Report() {
  return (
    <CommonLayout>
      <div>Report</div>
    </CommonLayout>
  );
}

export default Report;
